const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
const regExp = /\(([^)]+)\)/;
const matches = regExp.exec(userAgent);

const getOS = () => {
  const result = {
    isIos: false,
    isAndroid: false,
    isOthers: false, // all the desktop
    isMac: false, // only macintosh
    name: '',
    version: '-',
    majorVersion: 0,
  };
  const matchesString = matches && matches[1] ? matches[1].split(';') : [];

  if (/iP(ad|hone|od)/i.test(userAgent)) {
    let version = '';
    let majorVersion = '';
    for (let i = 0; i < matchesString.length; i += 1) {
      if (/ OS /i.test(matchesString[i])) {
        version = matchesString[i].replace(/[^0-9_]/g, '');
        majorVersion = matchesString[i].replace(/[^0-9_]/g, '').split('_')[0];
      }
    }
    result.version = version;
    result.majorVersion = parseInt(majorVersion, 10);
    result.isIos = true;
    result.name = 'iPhone/iPad';
  } else if (/Android/i.test(userAgent)) {
    let version = '';
    let majorVersion = '';
    for (let j = 0; j < matchesString.length; j += 1) {
      if (/Android/i.test(matchesString[j])) {
        version = matchesString[j].replace(/[^0-9.]/g, '');
        majorVersion = matchesString[j].replace(/[^0-9]/g, '')[0];
      }
    }
    result.version = version;
    result.majorVersion = parseInt(majorVersion, 10);
    result.isAndroid = true;
    result.name = 'Android';
  } else {
    result.isOthers = true;
    result.name = 'desktop';

    if (/Macintosh/i.test(userAgent)) {
      result.isMac = true;
      result.name = 'Macintosh';
    }
  }

  return result;
};

const getBrowser = () => {
  const detectBrowsers =
    /(Opera|Chrome|CriOS|SamsungBrowser|Safari|Firefox|FxiOS|Msie|Whale|Trident(?=\/))\/?\s*(\d+)/i;

  const detectVenders =
    /OPR|Whale|Electron|Crosswalk|Firefox|FxiOS|Edg|UCBrowser|ACHEETAHI|KAKAOTALK|Daum|Naver|FBAV|Instagram|LinkedInApp/i;

  const inAppBrowsers =
    /UCBrowser|KAKAOTALK|Daum|Naver|FBAV|Instagram|LinkedInApp/i;

  const result = {
    isChrome: false,
    isSafari: false,
    isSamsung: false,
    isOthers: false,
    isInApp: false,
  };

  if (detectVenders.test(userAgent)) {
    result.isOthers = true;
  } else if (/SamsungBrowser/i.test(userAgent)) {
    result.isSamsung = true;
  } else if (/Chrome|CriOS/i.test(userAgent)) {
    result.isChrome = true;
  } else if (/Safari/i.test(userAgent)) {
    result.isSafari = true;
  } else {
    result.isOthers = true;
  }

  if (inAppBrowsers.test(userAgent)) {
    result.isInApp = true;
  }

  return result;
};

const getDevice = () => {
  let result = {};

  if (/iP(ad|hone|od)/i.test(userAgent)) {
    result = matches && matches[1] ? { name: matches[1] } : { name: 'Unknown' };
  } else {
    result =
      matches && matches[1]
        ? { name: matches[1].split(';').pop().split('/')[0] }
        : { name: 'Unknown' };
  }

  return result;
};

// 서버 환경에서 window나 navigator가 없을 때 처리
function isTouchDevice() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false; // 서버에서는 터치 디바이스를 감지할 수 없음
  }
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

const getDeviceType = () => {
  if (typeof navigator === 'undefined') {
    return 'desktop'; // 서버 환경에서는 기본값으로 'desktop' 반환
  }
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet';
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/i.test(
      ua
    )
  ) {
    return 'mobile';
  } else if (isTouchDevice()) {
    return 'tablet';
  }
  return 'desktop';
};

const os = getOS();
const browser = getBrowser();
const device = getDevice();
export const deviceType = getDeviceType();

export const UserAgent = {
  os,
  browser,
  device,
  deviceType,
};
